<template>
  <v-card flat :border="true">
    <v-toolbar class="custom-bg" density="compact">
      <v-toolbar-title class="cap">{{ title}}</v-toolbar-title>
    </v-toolbar>
    <v-card-text :class="cardTextClass">
      <slot name="content"></slot>
    </v-card-text>
  </v-card>
</template>

<script setup lang="ts">
defineProps({
  title: {
    type: String,
    required: true
  },
  cardTextClass: {
    type: String,
    reuired: false
  }
})
</script>

<style lang="scss">
.cap {
  text-transform: capitalize;
}
</style>
